module.exports = __webpack_public_path__ + "static/media/photo-09.c294b386.png";